import { useCallback, useEffect, useState } from "react";
import { getDropDownOnlineChannel } from "../../services/customerStakeholder";

const useOnlineChannel = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getDropDownOnlineChannel();
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      setData(objectValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useOnlineChannel;
